import { ref } from 'vue';

type Toast={id:number;kind:'success'|'error'|'info';message:string};
const messages=ref<Toast[]>([]);
const timers=new Map<number,ReturnType<typeof setTimeout>>();
let next=0;

export function useToast(){
  function pause(id:number){clearTimeout(timers.get(id));timers.delete(id);}
  function remove(id:number){pause(id);messages.value=messages.value.filter(toast=>toast.id!==id);}
  function resume(id:number){
    pause(id);
    const toast=messages.value.find(item=>item.id===id);
    if(toast)timers.set(id,setTimeout(()=>remove(id),toast.kind==='error'?10000:6000));
  }
  function show(kind:Toast['kind'],message:string){
    const existing=messages.value.find(toast=>toast.kind===kind && toast.message===message);
    if(existing){resume(existing.id);return;}
    if(messages.value.length>=3)remove(messages.value[0]!.id);
    const id=++next;messages.value.push({id,kind,message});resume(id);
  }
  return {messages,remove,pause,resume,success:(message:string)=>show('success',message),error:(message:string)=>show('error',message),info:(message:string)=>show('info',message)};
}
